<template>
  <!--
      作者：kmdshop
      时间：2024-6-17
      描述：插件中心-进销存管理-编辑
    -->
    <el-dialog
    title="编辑"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
      <div class="product-add pb50" v-loading="loading">
        <!--编辑文章-->
        <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
          <div class="common-form">编辑</div>

          <el-form-item label="商品条形码" prop="product_bar_code"><el-input type="text" v-model="form.product_bar_code"
            placeholder="请输入商品条形码" class="max-w460"></el-input>
              </el-form-item>

          <el-form-item label="价格" prop="price"><el-input type="number" v-model="form.price"
            placeholder="请输入价格" class="max-w460"></el-input>
            <el-button size="small" style="margin-top: 20px;" type="primary" @click="useProductPrice" :loading="loading">采用原产品价格</el-button>
          </el-form-item>


       

     
          <!--提交-->
          <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc" :loading="loading">取消</el-button>
            <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
</template>

<script>
import PsinApi from '@/api/psin.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*form表单数据*/
      form: {
        price: 0,
      },

      /*验证规则*/
      rules: {
        price: [{ required: true, message: '请输入产品价格', trigger: 'blur' }],
      }
    };
  },
  props: ["open_edit","id"],
  created() {
    this.dialogVisible = this.open_edit;
    this.getDetail();

  },

  methods: {
      /*关闭弹窗*/
      dialogFormVisible() {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    useProductPrice(){
      this.form.price = this.form.product_price
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.id;
      PsinApi.detail({id: params},true).then(res => {
          self.form = res.data;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*修改任务*/
    onSubmit() {
      let self = this;
      let params = this.form;
      params.id =  self.id;
      // 取到路由带过来的参数
      PsinApi.edit(params, true)
        .then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          this.cancelFunc();
        })
        .catch(error => {

        });
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/psin/index/edit.vue